<template>
  <v-container>
    <v-toolbar color="toolbar" class="rounded-xxl">
      <v-toolbar-title>Changelog (V1)</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="getChangelog" icon>
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container :fluid="$vuetify.breakpoint.lgAndDown">
      <v-card
        v-for="item in changelog"
        :key="item.id"
        class="rounded-xl mb-2"
        color="card"
      >
        <v-toolbar color="toolbar">
          <v-toolbar-title>
            {{ item.version
            }}<v-chip
              class="ml-2"
              v-if="
                item.downgradable &&
                $store.state.versioning.version !== item.version
              "
              small
              color="grey"
              outlined
              :href="'/api/v1/changelog/downgrade/' + item.hash"
              >Downgrade</v-chip
            >
            <v-chip
              class="ml-2"
              small
              color="grey"
              outlined
              v-if="$store.state.versioning.version === item.version"
              >CURRENT VERSION</v-chip
            >
          </v-toolbar-title>
        </v-toolbar>
        <v-container
          :fluid="$vuetify.breakpoint.lgAndDown"
          style="white-space: pre-line"
        >
          {{ item.changelog }}<br />
          <small>
            Built At:
            {{ item.buildDate || "Unknown" }}</small
          ><br />
          <small>Hash: {{ item.hash }}</small>
          <br />
          <small v-if="item.v2" class="green--text">V2</small>
          <small v-if="!item.v2" class="red--text">V1</small>
        </v-container>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "Changelog",
  data() {
    return {
      changelog: []
    }
  },
  methods: {
    getChangelog() {
      this.axios.get("/api/v1/changelog").then((res) => {
        this.changelog = res.data.changelogs
      })
    }
  },
  mounted() {
    this.getChangelog()
  }
}
</script>

<style scoped></style>
